import { observable, action, makeObservable } from "mobx";
import announcementService from "../services/AnnouncementService";

const DEFAULT_W = 360;
const DEFAULT_H = 180;
const MIN_W = 280;
const MIN_H = 140;
const STACK_OFFSET = 12;

function clampRect(x, y, w, h) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const cw = Math.max(MIN_W, Math.min(w, vw - 16));
  const ch = Math.max(MIN_H, Math.min(h, vh - 16));
  const cx = Math.max(0, Math.min(x, vw - cw));
  const cy = Math.max(0, Math.min(y, vh - ch));
  return { x: cx, y: cy, w: cw, h: ch };
}

export class AnnouncementStore {
  @observable items = [];
  @observable loading = false;
  @observable error = null;
  @observable lastLoadedAt = null;
  @observable ui = new Map();
  @observable _topZ = 1;
  _dismissedIds = new Set();

  constructor() {
    makeObservable(this);
  }

  @action.bound
  fetchByOrganization = async () => {
    console.log("[AnnouncementStore] fetchByOrganization chamado");
    this.loading = true;
    this.error = null;
    try {
      const data = await announcementService.getByOrganization();
      console.log("[AnnouncementStore] resposta da API:", JSON.stringify(data));
      if (data === null || data === undefined) {
        console.log("[AnnouncementStore] data é null/undefined, items = []");
        this.items = [];
      } else {
        const all = Array.isArray(data) ? data : [];
        this.items = all.filter((item) => !this._dismissedIds.has(item.announcementId));
        console.log("[AnnouncementStore] items carregados:", this.items.length, this.items);
        this.items.forEach((item) => {
          console.log("[AnnouncementStore] ensureUiStateFor id:", item.announcementId);
          this.ensureUiStateFor(item.announcementId);
        });
      }
      this.lastLoadedAt = new Date();
    } catch (err) {
      console.error("[AnnouncementStore] erro:", err);
      this.error = err;
    } finally {
      this.loading = false;
      console.log("[AnnouncementStore] final - items:", this.items.length, "ui keys:", [...this.ui.keys()]);
    }
  };

  @action.bound
  clearError = () => {
    this.error = null;
  };

  @action.bound
  dismiss = (id) => {
    const item = this.items.find((i) => i.announcementId === id);
    if (item && item.dismissable) {
      this._dismissedIds.add(id);
      this.items = this.items.filter((i) => i.announcementId !== id);
      this.ui.delete(id);
    }
  };

  @action.bound
  bringToFront = (id) => {
    const state = this.ui.get(id);
    if (state) {
      this._topZ += 1;
      state.z = this._topZ;
    }
  };

  @action.bound
  setRect = (id, rect) => {
    const state = this.ui.get(id);
    if (!state) return;
    const { x, y, w, h } = clampRect(
      rect.x !== undefined ? rect.x : state.x,
      rect.y !== undefined ? rect.y : state.y,
      rect.w !== undefined ? rect.w : state.w,
      rect.h !== undefined ? rect.h : state.h
    );
    state.x = x;
    state.y = y;
    state.w = w;
    state.h = h;
  };

  @action.bound
  ensureUiStateFor = (id) => {
    if (this.ui.has(id)) return;
    const index = this.ui.size;
    this._topZ += 1;
    const vw = window.innerWidth;
    const baseX = vw - DEFAULT_W;
    const baseY = 0;
    const { x, y, w, h } = clampRect(
      baseX - index * STACK_OFFSET,
      baseY + index * STACK_OFFSET,
      DEFAULT_W,
      DEFAULT_H
    );
    this.ui.set(id, observable({ x, y, w, h, z: this._topZ }));
  };

  @action.bound
  logout = () => {
    this.items = [];
    this.loading = false;
    this.error = null;
    this.lastLoadedAt = null;
    this.ui = new Map();
    this._topZ = 1;
    this._dismissedIds.clear();
  };
}

const announcementStore = new AnnouncementStore();
export default announcementStore;
